import styled from "styled-components";
import { getTheme, Div, Text, Flow, Stream, } from "@bracket/ui";
import { getTabularRasaStore, } from "../RasaStore";
import { TabularRasaDefaultAccessor, TabularRasaEmptyAccessor, } from "../accessors";
import { RasaCardCell, } from "./RasaCardCell";
import { TRCell, } from "../shared";



export declare type RasaBodyProps<T extends Record<string, any>> = {
	id: string;
};



export const RasaBody = <T extends Record<string, any>>({ id, }: RasaBodyProps<T>) => {

	if(!id) throw new Error("RasaBody id is required");

	const { data, emptyDataSet, page, columnKeys, pk, rowMargin, rowPadding, bodyRowMargin, bodyRowPadding, deviceType, } = getTabularRasaStore(id)();
	const columnEntries = Array.from(columnKeys.entries());
	return (
		<TRBody>
		{
			emptyDataSet <= 0
				? ( <NoDataRow><Text>No data available</Text></NoDataRow> )
				: (
					page.map((row, idx) => {

						const isPaddingRow = columnEntries.every(([key, _]) => (row as Record<string, unknown>)[key] === "");
						const rowKey = pk ? String(row[pk]) : isPaddingRow ? `padding-${idx * Math.floor(Math.random() * 122000)}` : columnEntries.map(([k, _]) => String((row as Record<string, unknown>)[k] ?? "")).join("|") || `row-${idx}`;
						const RowComponent = deviceType === "MOBILE" ? TRMobileBodyRow : TRBodyRow;
						return (
							<RowComponent key={rowKey} $rowMargin={rowMargin} $rowPadding={rowPadding} $bodyRowMargin={bodyRowMargin} $bodyRowPadding={bodyRowPadding}>
							{
								columnEntries.map(([key, column]) => {
									const { hidden, justify, accessor, accessorData, label, width, } = column || {};
									if(hidden)
										return null;

									const valueType = typeof row[key];
									const cellKey = `${rowKey}-${key}`;
									const isPadding = row[key] === "";
									const cellContent = (
										isPadding
											? <TabularRasaEmptyAccessor accessorData={accessorData} />
											: typeof accessor === "function"
												? accessor({ prop: key, value: row[key], entry: row, data, accessorData, })
												: <TabularRasaDefaultAccessor label={label} value={row[key]} device={deviceType} accessorData={accessorData} />
									);
									if(deviceType === "MOBILE") {
										return (
											<RasaCardCell key={cellKey} label={label} basisPx={width} $grow={width} justify={justify}>
												{cellContent}
											</RasaCardCell>
										);
									}

									return (
										<TRCell
											key={`${rowKey}-${key}`}
											$width={width}

											$basisPx={width}
											$grow={width}
											$justify={justify}
											$minWidth={width}
											$maxWidth={width}>
											<MobileValueDiv>{cellContent}</MobileValueDiv>
										</TRCell>
									);
							})
						}
						</RowComponent>
					);
				})
			)
		}
		</TRBody>
	);
};

const TRBody = styled(Flow)`
	display: flex;
	flex-direction: column;
`;

const TRRow = styled(Stream)<{ $rowMargin?: string; $rowPadding?: string; }>`
	${({ $rowMargin }) => `margin: ${$rowMargin}` || ""};
	${({ $rowPadding }) => `padding: ${$rowPadding}` || ""};
`;

const TRBodyRow = styled(TRRow)<{ $bodyRowMargin?: string; $bodyRowPadding?: string; }>`
	${({ $bodyRowMargin }) => `margin: ${$bodyRowMargin}` || ""};
	${({ $bodyRowPadding }) => `padding: ${$bodyRowPadding}` || ""};
	@media (max-width: 768px) {
		border-bottom: 1px solid ${() => getTheme().outline};
		flex-direction: column;
		margin-bottom: 20px;
	}
`;

const NoDataRow = styled(TRBodyRow)`
	justify-content: center;
	align-items: center;
	padding: 4rem;
`;


const TRMobileBodyRow = styled(TRBodyRow)`
	padding-bottom: 1rem;
`;


const MobileValueDiv = styled(Div)`
	@media (max-width: 768px) {
		flex: 1;
	}
`;
